import * as _ from 'lodash';

angular.module("tromanWeb").controller('OrganizationEditController', ['stateService', 'tromanServer', 'dialogService', 'organizationState', 'systemInfo', function (stateService, tromanServer, dialogService, organizationState, systemInfo) {

    var isSaving = false;

    this.organization = organizationState.organization.clone();
    this.shared = organizationState;
    this.canChangeWageGroup = !!(this.organization.WageGroup == null || this.organization.WageGroup.CurrentRound == null || this.organization.WageGroup.CurrentRound.PaymentRound.IsLocked);
    this.enableMunicipalityCheck = !_.isEmpty(this.organization.ValidMunicipalities);
    this.isPolitikerEnabled = systemInfo.IsPolitikerEnabled;

    stateService.guard(() => this.shared.form.$dirty);

    this.canSave = function () {
        return this.organization != null && !isSaving && this.shared.form.$dirty && this.shared.form.$valid;
    };

    this.enableMunicipalityCheckChanged = function () {
        if (this.enableMunicipalityCheck && !_.isEmpty(organizationState.systemSettings.DefaultValidMunicipalities)) {
            this.organization.ValidMunicipalities = organizationState.systemSettings.DefaultValidMunicipalities.slice();
        } else {
            this.organization.ValidMunicipalities = [];
        }
    };

    this._enableHistoricMeetingDays = this.organization?.Publish?.HistoricMeetingDays > 0;
    Object.defineProperty(this, 'enableHistoricMeetingDays', {
        get: function() {
            return this._enableHistoricMeetingDays;
        },
        set: function(value) {
            this._enableHistoricMeetingDays = !!value;
            this.organization.Publish.HistoricMeetingDays = value ? 365 : 0;
        }
    });

    this.save = function save() {
        if (!this.canSave()) return;

        this.shared.form.$commitViewValue();
        this.shared.form.$setSubmitted();

        if (this.shared.form.$invalid) return;

        isSaving = true;
        if (this.organization.Id == null) {
            tromanServer.Organizations.addEntity(this.organization)
                .finally(() => { isSaving = false; })
                .then(rsp => {
                    stateService.forceGo('organization.details', { organizationId: rsp.result.Id }, { reload: true, location: 'replace' });
                })
                .catch(dialogService.error);
        } else {
            tromanServer.Organizations.updateEntity(this.organization)
                .finally(() => { isSaving = false; })
                .then(() => {
                    stateService.forceReload('organization');
                })
                .catch(dialogService.error);
        }
    };

}]);
